export default __webpack_public_path__ + "static/media/008-helicopter.c2c3fe35.png";